// アメニティのカテゴリー分け
export const AMENITY_CATEGORIES = {
    '基本設備': [
        { value: 'bath', label: 'バス・トイレ別' },
        { value: 'separate_toilet', label: '独立洗面台' },
        { value: 'washer', label: '室内洗濯機' },
        { value: 'utilities', label: '光熱費込み' },
        { value: '2nd_floor', label: '2階以上' }
    ],
    '家具・設備': [
        { value: 'furnished', label: '家具家電付き' },
        { value: 'aircon', label: 'エアコン' },
        { value: 'wifi', label: 'Wi-Fi' }
    ],
    '共用施設': [
        { value: 'parking', label: '駐車場' },
        { value: 'bicycle', label: '駐輪場' },
        { value: 'storage', label: '収納あり' }
    ],
    'セキュリティ': [
        { value: 'autolock', label: 'オートロック' }
    ],
    'その他': [
        { value: 'pets', label: 'ペットOK' }
    ]
};

// アメニティのラベルマッピング
export const AMENITY_LABELS = Object.values(AMENITY_CATEGORIES).reduce((acc, categoryAmenities) => {
    categoryAmenities.forEach(({ value, label }) => {
        acc[value] = label;
    });
    return acc;
}, {}); 